import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { api } from 'constants/api';
import { ApiError, ApiResponse } from 'types/utils/api-response';
import { QueryOptions } from 'types/utils/query-options';

export type PurchaseHistory = {
  id: number;
  user_id: number;
  business_id: number;
  adjustment_reason?: string | null;
  adjusted_by_name?: string | null;
  balance_before?: number | null;
  balance_after?: number | null;
  error_msg?: null | unknown;
  date: Date;
  status: string;
  purchased_credits: number;
  /**
  CHECKOUT value divide by 100
  */
  purchased_amount: number;
};

export const useGetPurchaseHistory = (
  options: QueryOptions<PurchaseHistory[], AxiosError<ApiError>> = {}
) =>
  useQuery({
    queryFn: async (): Promise<PurchaseHistory[]> => {
      const { data } =
        await api.get<ApiResponse<PurchaseHistory[]>>(`/purchase/history`);

      return data.data;
    },
    queryKey: ['purchase/history'],
    ...options,
  });
